"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MultiTargetStrategy_1 = require("./MultiTargetStrategy");

var StrategyTypeEnum_1 = require("./StrategyTypeEnum");
/**
 * Define the relations with the relevant competitors. Only one strategy and distance can be applied.
 *
 * @author RV
 */


var FollowMostExpensive =
/*#__PURE__*/
function (_MultiTargetStrategy_) {
  _inherits(FollowMostExpensive, _MultiTargetStrategy_);

  /**
   * @param competitorIds
   */
  function FollowMostExpensive(competitorIds) {
    var _this;

    _classCallCheck(this, FollowMostExpensive);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FollowMostExpensive).call(this, competitorIds));
    _this.competitorIds = competitorIds;
    return _this;
  }

  _createClass(FollowMostExpensive, [{
    key: "getType",
    value: function getType() {
      return StrategyTypeEnum_1.StrategyTypeEnum.FollowMostExpensive;
    }
  }]);

  return FollowMostExpensive;
}(MultiTargetStrategy_1.MultiTargetStrategy);

exports.FollowMostExpensive = FollowMostExpensive;